import { useEffect, useState } from 'react';
import { useData } from './dataContext';
import { classGroupDay, filterBySubject } from '../utils/filterTools'


export const useCustomData = () => {
    const { sheetData, isLoading, isError, refresh } = useData()
    const [subjetList, setSubjetList] = useState(null)
    const [classGroupWeek, setClassGroupWeek] = useState([])

    useEffect(() => {
        if (sheetData && !isLoading) {
            setClassGroupWeek(sheetData.map(s => new classGroupDay(s)))
            setSubjetList(filterBySubject(sheetData))
        }
    }, [sheetData])

    useEffect(() => {
        if (subjetList) {
            //console.log(subjetList);
            //console.log(ClassGroup)
        }
    }, [subjetList]);

    return {
        isLoading,
        isError,
        classGroupWeek,
        refresh
    };
};

export default useCustomData;